import React from 'react';
import {
  BellOutlined,
  CalendarOutlined,
  CheckSquareOutlined,
  CoffeeOutlined,
  CreditCardOutlined,
  ExperimentOutlined,
  FormOutlined,
  HeartOutlined,
  InboxOutlined,
  MedicineBoxOutlined,
  ShoppingCartOutlined,
  ToolOutlined,
  UserOutlined,
} from '@ant-design/icons';

/** Notification categories; keys match AppNotification::CATEGORIES in the backend. */
export const NOTIFICATION_CATEGORIES = {
  alert: { label: 'Field reports', icon: <FormOutlined />, color: 'blue' },
  task: { label: 'Tasks', icon: <CheckSquareOutlined />, color: 'cyan' },
  schedule: { label: 'Schedules', icon: <CalendarOutlined />, color: 'geekblue' },
  breeding: { label: 'Breeding', icon: <HeartOutlined />, color: 'magenta' },
  health: { label: 'Health', icon: <MedicineBoxOutlined />, color: 'red' },
  milk: { label: 'Milk', icon: <ExperimentOutlined />, color: 'volcano' },
  feed: { label: 'Feed', icon: <CoffeeOutlined />, color: 'gold' },
  stock: { label: 'Stock', icon: <InboxOutlined />, color: 'orange' },
  maintenance: { label: 'Maintenance', icon: <ToolOutlined />, color: 'lime' },
  sales: { label: 'Sales', icon: <ShoppingCartOutlined />, color: 'green' },
  billing: { label: 'Billing', icon: <CreditCardOutlined />, color: 'purple' },
  account: { label: 'Account', icon: <UserOutlined />, color: 'default' },
  system: { label: 'General', icon: <BellOutlined />, color: 'default' },
};

export const categoryMeta = (key) => NOTIFICATION_CATEGORIES[key] || NOTIFICATION_CATEGORIES.system;
